import {
  useBlockedNumbers,
  useCanBlockNumber,
  useFindBlockedNumber,
} from '~/atoms/BlockedNumbersState'

export const useToggleBlockedNumberButtonViewModel = (
  phoneNumber: string | null | undefined,
) => {
  const {
    blockedNumbers,
    unblockNumber: __unblockNumber,
    blockNumber: __blockNumber,
    blockNumberWithConfirmation: __blockNumberWithConfirmation,
    isBlocking,
    isUnblocking,
  } = useBlockedNumbers()

  const canBlockNumber = useCanBlockNumber(phoneNumber)

  const blockedNumber = useFindBlockedNumber(blockedNumbers, phoneNumber)

  const unblockNumber = () => {
    if (!blockedNumber) {
      return
    }

    __unblockNumber(blockedNumber.id, blockedNumber.phoneNumber)
  }

  const blockNumberWithConfirmation = () => {
    if (!phoneNumber) {
      return
    }
    __blockNumberWithConfirmation(phoneNumber)
  }

  return {
    isBlocking,
    isUnblocking,
    isNumberBlocked: !!blockedNumber,
    canBlockNumber,
    blockNumberWithConfirmation,
    unblockNumber,
  } as const
}
